import React, { useState } from "react"
import { Plane } from "lucide-react"
import PlaneImg from "../../../../../assets/avia/ticket/plane.png"
import { useTranslation } from "react-i18next"

const FlightRoute = ({ from, to, duration, stops = [], isDirect = true, airline, date }) => {
  const { t } = useTranslation()

  const [hoveredTooltip, setHoveredTooltip] = useState(null)

  return (
    <div className="w-full relative">
      {/* Линия маршрута */}
      <div className="absolute top-[40%] left-[5%] right-[5%] xl:left-[3%] xl:right-[3%] border-t-2 border-gray-400"></div>

      {/* Точка отправления */}
      <div className="absolute top-[40%] left-[1.5%] xl:left-[1%] w-[10px] h-[10px] -translate-y-1/2 rounded-full border-2 border-gray-400 bg-white"></div>

      {/* Точка прибытия */}
      <div className="absolute top-[40%] right-[1.5%] xl:right-[1%] w-[10px] h-[10px] -translate-y-1/2 rounded-full border-2 border-gray-400 bg-white"></div>

      <div className="absolute top-[40%] left-1/2 flex items-center justify-center w-10 h-10 p-1 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full">
        <img className="w-full rotate-90" src={PlaneImg} alt="" />
      </div>

      <div className="text-center absolute -top-6 left-1/2 -translate-x-1/2 mt-8">
        <span className="text-xs text-gray-600">{duration}</span>
      </div>

      <div className="flex items-center justify-between w-full gap-2">
        <div
          className="flex flex-col gap-3 items-start text-left flex-shrink-0 flex-grow-0"
          style={{ flexBasis: "25%", minWidth: "80px", maxWidth: "120px" }}
          onMouseEnter={() => setHoveredTooltip("from")}
          onMouseLeave={() => setHoveredTooltip(null)}
        >
          {hoveredTooltip === "from" && (
            <Tooltip
              data={{
                code: from.code,
                city: from.city,
                time: from.time,
                date: date,
                airline: airline,
              }}
              position="left"
              t={t}
            />
          )}
          <div className="text-xl font-bold text-gray-700 truncate w-full">{from.time}</div>
          <div className="w-full">
            <div className="text-sm font-semibold text-blue-700 truncate w-full">{from.code}</div>
            <div className="text-sm text-black truncate w-full">{from.city}</div>
          </div>
        </div>

        <div className="flex-1 relative flex flex-col justify-between min-w-0">
          {isDirect && (
            <div className="relative h-16 -bottom-12 flex justify-center items-center">
              <button className="rounded-xl border border-blue-500 text-blue-500 px-3 py-1 text-xs whitespace-nowrap">
                {t("admin.straight")}
              </button>
            </div>
          )}

          <div className="flex justify-around min-h-[32px] mt-4">
            {stops.length > 0 &&
              stops.map((stop, index) => (
                <div key={index} className="flex flex-col items-center">
                  <div className="text-xs font-semibold text-gray-700 mb-0.5">{stop.code}</div>
                  <div className="text-xs text-gray-500">{stop.city}</div>
                </div>
              ))}
          </div>
        </div>

        {/* Прибытие */}
        <div
          className="flex flex-col items-end text-right flex-shrink-0 flex-grow-0 gap-3"
          style={{ flexBasis: "25%", minWidth: "80px", maxWidth: "120px" }}
          onMouseEnter={() => setHoveredTooltip("to")}
          onMouseLeave={() => setHoveredTooltip(null)}
        >
          {hoveredTooltip === "to" && (
            <Tooltip
              data={{
                code: to.code,
                city: to.city,
                time: to.time,
                date: date,
                airline: airline,
              }}
              position="right"
              t={t}
            />
          )}
          <div className="text-xl font-bold text-gray-700 truncate w-full">{to.time}</div>
          <div className="w-full">
            <div className="text-sm font-semibold text-blue-700 truncate w-full">{to.code}</div>
            <div className="text-sm text-black truncate w-full">{to.city}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FlightRoute

const Tooltip = ({ data, position, t }) => (
  <div
    className={`absolute ${
      position === "left" ? "left-0" : "right-0"
    } top-0 mt-2 w-64 bg-info-main rounded-lg shadow-lg p-2 z-50`}
  >
    <div className="flex items-center text-white gap-1 text-[10px] flex-wrap">
      <span>{position === "left" ? t("admin.departure") : t("transport.arrival")}:</span>{" "}
      <p>
        {data.city} ({data.code}), {t("requests.time")} - {data.time}
      </p>
    </div>
  </div>
)
